import { io } from "socket.io-client";
import { API_URL } from 'state/constants';

let socket = null;

export const initSocket = (userId) => {
  if (!socket && userId) {
    const serverOrigin = new URL(API_URL).origin;
    socket = io(serverOrigin);
    socket.on("connect", () => {
      socket.emit("user-connected", userId);
    });
  }
  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = (userId) => {
  if (socket) {
    socket.emit("user-disconnect", userId); // Optional, if you handle this server-side
    socket.disconnect();
    socket = null;
  }
};
